import { makeStyles } from '@mui/styles';
import { Button } from 'apollo-react';
import classNames from 'classnames';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';

const useStyles = makeStyles({
  root: {
    backgroundColor: 'white',
    height: 64,
    width: '100%',
    borderTop: 'solid 1px #e9e9e9',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 32,
    '& button': {
      marginRight: 16,
    },
    '& span[ui-ta="FormCtrl SSButton Cancel"]': {
      order: 1,
    },
    '& span': {
      order: 2,
    },
    '& span[ui-ta="FormCtrl SSButton Save"]': {
      order: 3,
    },
    '& span[ui-ta="FormCtrl SSButton SaveOffline"]': {
      order: 4,
    },
  },
  fixedContainer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: 10,
    paddingLeft: 0,
    overflowX: 'hidden',
    flexDirection: 'row-reverse',
  },
  buttonsContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});

const FooterButtons = ({ buttons = [] }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  return (
    <div
      ui-ta={getUITA('app-migration-buttons')}
      className={classNames(classes.root, classes.fixedContainer)}
    >
      <div className={classes.buttonsContainer}>
        {buttons.map((button, index) => (
          <Button key={index} {...button}>
            {translateString(button.label)}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default FooterButtons;
